import { Box, Stack } from "@mui/material";

import { useIsMobile } from "../../hooks/useIsMobile";
import { PageLayout } from "../../layouts";

interface CommandLinkLandingLayoutProps {
  children: React.ReactNode;
  maxWidth?: string;
  // Overrides the default top margin, which suits a short, centred card.
  marginTop?: string;
}

export function CommandLinkLandingLayout(props: CommandLinkLandingLayoutProps) {
  const { children, maxWidth = "600px", marginTop } = props;
  const isMobile = useIsMobile();

  return (
    <PageLayout>
      <Stack alignItems="center">
        <Box
          mt={marginTop ?? (isMobile ? "2rem" : "4rem")}
          width={isMobile ? "90%" : "85%"}
          maxWidth={maxWidth}
        >
          {children}
        </Box>
      </Stack>
    </PageLayout>
  );
}
